import * as React from 'react'
import { TScheduler } from './types'
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormControl } from 'baseui/form-control';
import { Datepicker, } from 'baseui/datepicker';
import { useStyletron } from 'baseui';
import { useIntl, FormattedMessage } from 'react-intl';
import { ValueCellSelector } from './components/ValueCellSelector';
import { getValueOptions } from './utils';
import { useGetLanguage } from '../../../hooks/useGetLanguage';
import { Banner } from 'baseui/banner';
import { Button } from 'baseui/button';
import { HorizontalStackPanel } from '../../../components/Layout/StackPanel';

export const ConfigurationPanel = (props: TScheduler) => {
    const { locale } = useGetLanguage();
    const [css, theme] = useStyletron();
    const intl = useIntl();


    const dateFrom = props.dateFrom ? new Date(props.dateFrom) : undefined;
    const dateTo = props.dateTo  ? new Date(props.dateTo) : undefined;


    const fromDateUndefined =  !dateFrom || dateFrom.getFullYear() < 1900 || dateFrom.getFullYear() >= 2049;
    const toDateUndefined = !dateTo || dateTo.getFullYear() < 1900 || dateTo.getFullYear() >= 2049;

    const [timeRange, setTimeRange] = React.useState<any[]>([fromDateUndefined ? undefined : dateFrom, toDateUndefined ? undefined : dateTo]);
    function onSetTimeRange(date: Date | Date[]) {        // setTimeRange(Array.isArray(date) ? date : [date])   
    }

    const [defaultValue, setDefaultValue, setDefaultValueResult, sendDefaultValueNow] = useSetObjectValue(props.id, props.resourceGroupId, "defaultValue", props.defaultValue, 1500);
    const onDefaultValueChanged = (value: boolean | number | null) => { setDefaultValue(value); }
    const onDefaultValueBlur = (value: boolean | number | null) => { sendDefaultValueNow(value) }

    const valueOptions = getValueOptions(props);
    return (
        <>
            <FormControl
                disabled={setDefaultValueResult.isLoading}
                error={setDefaultValueResult.isError}
                label={() => intl.formatMessage({ id: "Scheduler.DefaultValue", defaultMessage: "Default Value" })}
                caption={() => intl.formatMessage({ id: "Scheduler.DefaultValueDescr", defaultMessage: "Enter a value to be used, if there is no entry for the current time" })}>
                    <ValueCellSelector onValueBlur={onDefaultValueBlur} dataType={props.dataType} valueOptions={valueOptions} value={defaultValue} onValueChanged={onDefaultValueChanged}></ValueCellSelector>

            </FormControl>

            <FormControl
                disabled
                label={() => intl.formatMessage({ id: "dateFromTo", defaultMessage: "Date from/to" })}
                caption={() => intl.formatMessage({ id: "dateFromToDescr", defaultMessage: "Select the Date from and Date to" })}>
                <>
                    {(fromDateUndefined && toDateUndefined) &&
                        <Banner><FormattedMessage id="Scheduler.AnyTimeValid" defaultMessage="This scheduler has no date range defined. It is valid on any date." /></Banner>

                    }
                    <Datepicker
                        value={timeRange}
                        onChange={({ date }) => onSetTimeRange(date)}
                        quickSelect
                        range
                        clearable
                        locale={locale}
                        startDateLabel=''
                        endDateLabel=''
                        separateRangeInputs
                    />
                </>

            </FormControl>

        </>
    )
}
